import { Route, Routes } from "react-router-dom";

import { usePageTitle } from "@app/utils/hooks";

import TeamDetail from "./TeamDetail";
import TeamSettings from "./TeamSettings";
import TeamsHome from "./TeamsHome";

const Teams = () => {
  usePageTitle("Workspace Settings - Teams");

  return (
    <Routes>
      <Route index element={<TeamsHome />} />
      <Route path=":teamId" element={<TeamDetail />} />
      <Route path=":teamId/settings" element={<TeamSettings />} />
    </Routes>
  );
};

export default Teams;
